import { render, staticRenderFns } from "./AdminEditor.vue?vue&type=template&id=4eb0f7f6"
import script from "./AdminEditor.vue?vue&type=script&lang=js"
export * from "./AdminEditor.vue?vue&type=script&lang=js"
import style0 from "./AdminEditor.vue?vue&type=style&index=0&id=4eb0f7f6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports